import React from 'react';
import PropTypes from 'prop-types';
import { LabelLinkWrapperExt, LabelLinkWrapperInt } from './styles';
import Label from '../Label';
import IconFont from '../IconFont';

const LabelLink = ({
  label, color, size, path, isInternal, weight, classNameCustom, disableLink,
}) => (
  <div className={classNameCustom}>
    {isInternal ? (
      label &&
      <LabelLinkWrapperInt to={path}>
        <Label
          color={color}
          size={size}
          label={label}
          weight={weight}
          disableLink={disableLink}
        />
        {!disableLink &&
          <IconFont
            className="icon-matchcenter-right-arrow competition-title-row-arrow"
            color={color}
            font={10}
            marginLeft={0.3}
            marginTop={0.4}
            weight="bold"
            withCursor
          />
        }
      </LabelLinkWrapperInt>
      )
      : (
        <LabelLinkWrapperExt href={path} disableLink={disableLink}>
          <Label
            color={color}
            size={size}
            label={label}
            weight={weight}
            disableLink={disableLink}
          />
          {!disableLink &&
            <IconFont
              className="icon-matchcenter-right-arrow competition-title-row-arrow"
              color={color}
              font={10}
              marginLeft={0.3}
              marginTop={0.4}
              weight="bold"
              withCursor
            />
          }
        </LabelLinkWrapperExt>
      )
    }
  </div>
);

LabelLink.propTypes = {
  classNameCustom: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  path: PropTypes.any,
  isInternal: PropTypes.any,
  weight: PropTypes.string,
  disableLink: PropTypes.bool,
};

export default LabelLink;
